import { useEffect, useRef } from 'react'

export const useOutsideClick = <T extends HTMLElement>(outSideClick?: (e: MouseEvent) => void, active = true) => {
  const ref = useRef<T>(null)

  useEffect(() => {
    if (!active) return

    const handleClickOutside = (e: MouseEvent) => {
      if (ref.current && !ref.current.contains(e.target as Node)) {
        outSideClick?.(e)
      }
    }

    document.addEventListener('mousedown', handleClickOutside)
    return () => {
      document.removeEventListener('mousedown', handleClickOutside)
    }
  }, [active])

  return ref
}
